<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import VueBootstrapAutocomplete from '@vue-bootstrap-components/vue-bootstrap-autocomplete'
import ErrorAlert from '../../../components/errorAlert.vue';
import { toast, variants } from "@/helpers/toaster";

export default {
  page: {
    title: "Limiti",
  },
  components: {PageHeader, Layout, VueBootstrapAutocomplete, ErrorAlert},
  props: {
  },
  data() {
    return {
      title: 'Limiti',
      employeeQuery: '',
      sortDesc: true,
      search: '',
      fields: [
        {key: 'item.id', label: 'ID', sortable: false},
        {key: 'item.name2', label: 'Artikal', sortable: false},
        {key: 'item.price', label: 'Cena', sortable: false},
        {key: 'limit', label: 'Limit', sortable: false, editable: true},
      ],
      selectedEmployee: null,
      employees: [],
      limits: [],
      showItemsWithLimit: false,
      administrators: [],
    }
  },
  watch: {
    showItemsWithLimit() {
      this.search = '';
    },
    employeeQuery(v) {
      if (!this.employees.find(e => e.object_name === v)) {
        this.selectedEmployee = null;
      }
    },
    selectedEmployee() {
      this.loadLimits();
    },
  },
  computed: {
    isSaveDisabled() {
      return false;
    },
    searchedLimits () {
      let searched = this.limits.filter((limit) => {
        return limit.item?.name2?.toLowerCase().includes(this.search.toLowerCase())
      })

      if (this.showItemsWithLimit) {
        searched = searched.filter((item) => 
        (item.value !== null && item.value !== undefined)
        || (item.limit !== null && item.limit !== undefined));
      }

      return searched;
    },
  },
  async created() {
    this.$store.commit('loader/START_LOADING');

    try {
      await axios.get('/admin/employees/getForAdmin').then(response => {
        this.employees = response.data;
      })
      await this.loadLimits();
    } catch (e) {
      // eslint-disable-next-line no-empty
    } finally {
      this.$store.commit('loader/END_LOADING');
    }
  },
  methods: {
    async loadLimits() {
      this.limits=[]

      let url = `/admin/allLimits`;
      if (this.selectedEmployee) {
        url = url + `/${this.selectedEmployee.id}`
      }
      this.$store.commit('loader/START_LOADING');
      await axios.get(url).then((response => {
        this.limits = response.data;
      })).finally(() => this.$store.commit('loader/END_LOADING'));
    },
    async save() {
      const data = this.limits.filter(l => l.value || l.value === '' || l.value === '0').map((l) => {
        return {
          id: l.id,
          item_id: l.item.id,
          pricelist_id: l.pricelist_id,
          partner_id: l.partner_id,
          object_id: l.object_id,
          limit: l.value ? l.value: null,
        }
      });
      this.$store.commit('loader/START_LOADING');

      try {
        const response = await axios.patch('admin/bulkLimits', {data})

        if (response.data) {
          for (let i = 0; i < response.data.length; i++) {
            let item = this.limits.find((l) => l.item.id === response.data[i].item_id);
            if (!item.id) item.id = response.data[i].id;
          }
        }
        toast('Uspešno snimanje limita.', variants.SUCCESS)
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async downloadLimits() {
      this.$store.commit('loader/START_LOADING');
      let endpoint = `/admin/limits/export`;
      
      if (this.selectedEmployee) {
        endpoint = endpoint + `/${this.selectedEmployee.id}`
      }

      try {
        const response = await axios.get(endpoint, {
          responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'limiti.xlsx');
        document.body.appendChild(link);
        link.click();
        toast('Uspešno preuzimanje limita.', variants.SUCCESS)
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    onLimitEdit(item, value) {
      this.$set(item, 'value', value)
      this.$set(item, 'limit', value)
    },
  }
}
</script>

<template>
  <Layout>
    <error-alert />
    <PageHeader :title="title"/>
    <div class="row mb-2">
      <div class="col-12 col-sm-6 d-flex">
        <label class="col-form-label mr-2" for="employees">Objekat:</label>
        <VueBootstrapAutocomplete
          class="autocomplete"
          id="employees"
          v-model="employeeQuery"
          :data="employees"
          :serializer="(item) => item.object_name"
          :minMatchingChars="0"
          showOnFocus
          @hit="selectedEmployee = $event"
        />
      </div>
      <div class="col-12 col-sm-6 text-right">
        <b-dropdown right variant="primary" size="md" class="mr-2">
          <template slot="button-content">
            <i class="fas fa-file-download mr-1"></i>
            Preuzmi
            <i class="mdi mdi-chevron-down"></i>
          </template>
          <b-dropdown-item @click="downloadLimits()">Limiti - Excel</b-dropdown-item>
        </b-dropdown>
        <b-button type="button" variant="success" @click="save()" :disabled="isSaveDisabled">Snimi</b-button>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <div class="search-box chat-search-box mb-2">
          <div class="position-relative">
            <input v-model="search" type="text" class="form-control" placeholder="Pretraži..."/>
            <i class="bx bx-search-alt search-icon"></i>
            <i class="bx bx-x clear-icon" @click="search = ''"></i>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 align-items-center justify-content-end d-flex">
        <b-form-checkbox
                v-model="showItemsWithLimit"
                :value="true"
                :unchecked-value="false"
                switch
        >
          Prikaži samo artikle sa limitima
        </b-form-checkbox>
      </div>
      <div class="col-12 col-md-6 align-items-center justify-content-end d-flex"></div>
    </div>

    <div class="card">
      <div class="card-body">
        <b-table :items="searchedLimits" :fields="fields" striped responsive
                 class="border-left border-right border-bottom"
        >
          <template v-slot:cell(item.name2)="data">
            <a target="_blank" :href="`https://www.bigznet.rs/index.php?route=product/product&product_id=${data.item.item.id}`">{{ data.item.item.name2 }}</a>
          </template>
          <template v-slot:cell(limit)="data">
            <div v-if="data.field.editable">
              <b-form-input v-model="data.value" @input="onLimitEdit(data.item, data.value)" type="number" />
            </div>
            <div v-else>
              <h1>{{ data.value }}</h1>
            </div>
          </template>
          <template v-slot:cell(item.price)="data">
            {{ data.value }} RSD
          </template>
        </b-table>

      </div>
    </div>
  </Layout>
</template>

<style scoped>
  .search-box .form-control {
    border-radius: 0.25rem;
  }
  .autocomplete {
    width: 100%;
  }

  .limitlabel {
    text-wrap: nowrap;
  }
</style>
